const tags = document.querySelectorAll(".Blog .blog-tag");
const postsContainer = document.getElementById("blog-posts");
const postsTitle = document.getElementById("blog-title");
var activeTags = [];
document.querySelectorAll(".blog-tag.active").forEach((el) => {
  activeTags.push(parseInt(el.dataset.id));
});
listenTagLinks(tags);

function listenTagLinks(tags) {
  tags.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      const url = el.getAttribute("href");

      // if all tags are active
      if (activeTags.length == tags.length) {
        tags.forEach((el) => {
          el.classList.remove("active");
          el.classList.add("inactive");
        });
        activeTags = [];
      }

      // if no active tags deselect all
      if (!activeTags.length) {
        tags.forEach((el) => {
          el.classList.remove("active");
          el.classList.add("inactive");
        });
      }

      // set active / inactive
      if (activeTags.includes(parseInt(el.dataset.id))) {
        activeTags = activeTags.filter(
          (item) => item !== parseInt(el.dataset.id)
        );
        el.classList.add("inactive");
        el.classList.remove("active");
      } else {
        activeTags.push(parseInt(el.dataset.id));
        el.classList.add("active");
        el.classList.remove("inactive");
      }

      // if no active tags select all
      if (!activeTags.length) {
        tags.forEach((el) => {
          el.classList.add("active");
          el.classList.remove("inactive");
        });
      }

      getPosts(activeTags);
    });
  });
}

async function getPosts(activeTags) {
  const url =
    config.blogPage.url +
    "?" +
    activeTags.map((value, index) => `tags[${index}]=${value}`).join("&");

  const req = new Request(url, {
    headers: new Headers({
      "X-Requested-With": "XMLHttpRequest",
    }),
  });
  const resp = await fetch(req).then((r) => r.json());
  postsContainer.style.minHeight = postsContainer.clientHeight + "px";
  postsContainer.classList.add(
    "transition-all",
    "-translate-y-10",
    "opacity-0"
  );
  setTimeout(() => {
    postsTitle.innerHTML = resp.title
    postsContainer.innerHTML = resp.posts;
    document.getElementById("pagination").innerHTML = resp.pagination;
    postsContainer.classList.remove("-translate-y-10", "opacity-0");
    postsContainer.style.minHeight = "";
  }, 300);
}
